import { t } from "@/i18n-js/instance";
import { useRecommendationsInfiniteQuery } from "@/react/hooks/recommendations/useRecommendationsInfiniteQuery";
import type { Person } from "@/react/types/AudienceList";
import type { ExpandableAccordionItem } from "../../shared/ExpandableAccordion";
import { ExpandableAccordion } from "../../shared/ExpandableAccordion";

const i18nBase = "members_directory.recommendations";

export const Recommendations = () => {
  const recommendationsQuery = useRecommendationsInfiniteQuery({
    perPage: 2,
  });
  const recommendations = recommendationsQuery.recommendations || [];
  const hasMore = Boolean(recommendationsQuery.hasNextPage);

  const items: ExpandableAccordionItem[] = recommendations.map(item => ({
    id: `${item.id}`,
    person: item.target as Person,
    type: "recommendation",
  }));

  return (
    <ExpandableAccordion
      title={t(`${i18nBase}.title`)}
      items={items}
      totalCount={recommendationsQuery.count ?? 0}
      isLoading={Boolean(recommendationsQuery.isLoading)}
      hasMore={hasMore}
      fetchNextPage={recommendationsQuery.fetchNextPage}
      isFetchingNextPage={Boolean(recommendationsQuery.isFetchingNextPage)}
      className="mx-2"
      totalCountClassName="bg-secondary text-dark"
    />
  );
};
